import LocalizationEntity from "../../../../../domain/entities/localization.entity";
import LocalizationList from "./dictionaries/LocalizationList";

const GetAvailableLanguagesApiImpl = async (): Promise<LocalizationEntity[]> => LocalizationList;

export default GetAvailableLanguagesApiImpl;